import { SharingLead } from '@prisma/client'
import { AxiosResponse } from 'axios'
import { post } from 'utilities/api'

export type CreateSharingLeadField = 'url' | 'emailAddress'
  // include fields below here too

export type CreateSharingLead = {
  // only allow keys from SharingLead table here
  url: string,
  emailAddress: string,
}

export const createSharingLead = async (lead: CreateSharingLead) => {
  const createdSharingLead = await post('/sharing/lead', lead)
  console.log({ createdSharingLead })
  return createdSharingLead.data
}

export const verifyLeadEmailAddress = async (confirmationCode: string) => {
  const isVerified = await post('/sharing/lead/verification', {
    confirmationCode,
  })
  console.log({ isVerified })
  return isVerified
}
